import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from "rxjs";
import {MessageItem} from "./message.item";
import {filter, map} from "rxjs/operators";
import {AbstractService} from "../abstract.service";
import {NotificationRepo} from "../../repositories/api/notification.repo";
import {NotificationsItem} from "./notifications.item";
import {NotificationDto} from "../../repositories/dto/notification.dto";
import {isDefined, isOrg, isUuid} from "../../libs/utils/epic.utils";

/**
 * Messages are displayed in the top right-hand corner and disappear after a while.
 * Angular generates messages.
 *
 * Notifications are displayed in the block and are permanently visible.
 * Notifications are delivered from the backend.
 */
@Injectable({providedIn: 'root'})
export class NotificationService extends AbstractService {

  private readonly notificationRepo: NotificationRepo = this.repoProvider.getRepo(NotificationRepo);

  private readonly message: Subject<MessageItem> = new Subject<MessageItem>();
  // private readonly messages = new BehaviorSubject<MessageItem[]>([]);
  private readonly notifications: BehaviorSubject<NotificationsItem> = new BehaviorSubject<NotificationsItem>(new NotificationsItem());

  constructor() {
    super();
    this.stateService.getClientNotification()
      .pipe(filter((n) => n === 'NOTIFICATION_UPDATE'))
      .subscribe(() => this.loadNotifications());
    this.stateService.getOrgDistinct()
      .subscribe(() => this.loadNotifications());
  }

  public getMessage(): Observable<MessageItem> {
    return this.message.asObservable();
  }

  public addSuccessMessage(message: string): void {
    const msg: MessageItem = {message, icon: 'success', success: true};
    this.message.next(msg);
  }

  public addErrorMessage(message: string): void {
    const msg: MessageItem = {message, icon: 'error', error: true};
    this.message.next(msg);

    /*
    const messages = this.messages.value;
    if (messages.length > this.maxMessages) {
      messages.shift();
    }
    messages.push(msg);
    this.messages.next(messages);
    */
  }

  public getNotifications(): Observable<NotificationsItem> {
    return this.notifications.asObservable();
  }

  private loadNotifications(): void {
    if (!isOrg(this.getOrg())) {
      return;
    }
    this.getAll().subscribe((notifications) => {
      this.notifications.next(new NotificationsItem({notifications}));
    });
  }

  private getAll(): Observable<NotificationDto[]> {
    return this.notificationRepo.getAll(this.getOrg())
      .pipe(map((w) => w.getDatas()));
  }

  public markAsRead(notification: NotificationDto): void {
    if (isDefined(notification) && isUuid(notification.id)) {
      this.notificationRepo.markAsRead(this.getOrg(), notification.id).subscribe();
    }
  }
}
